<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="services-reports"
      :filtersValue="filtersValue"
      :sort="sort"
      :date="date"
    ></filtered-data>
    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">Обслуживание</h1>
        <el-date-picker
          class="mr-2"
          v-model="date"
          type="datetimerange"
          :clearable="false"
          value-format="yyyy-MM-ddTHH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          align="right"
          range-separator="–"
          :picker-options="pickerOptions"
          size="small"
        />
        <btn-filters
          :data="data"
          endpoint="services-reports"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>

    <data-table-full-height
      v-if="data && data.data"
      :data="data.data"
      @sort-change="sortChange"
      show-summary
    >
      <table-column-serial-number :fixed="true"/>
      <el-table-column prop="address" label="Адрес установки" :show-overflow-tooltip="true" min-width="300"/>
      <table-column-number align="center" prop="services_planned_count" label="Количество плановых сервисов" min-width="120"/>
      <table-column-number sortable="custom" align="center" prop="planned" label="Количество выполненных плановых сервисов" min-width="120"/>
      <table-column-number sortable="custom" align="center" prop="casual" label="Количество выполненных внеплановых сервисов" min-width="120"/>
      <el-table-column sortable="custom" align="center" prop="late" label="Количество сервисов, выполненных с нарушением плановых сроков" min-width="120">
        <template slot-scope="{row}">
          <router-link :to="'/service?filters=' + makeQuery(row.serial_number)">
            <number :number="row.late"/>
          </router-link>
        </template>
      </el-table-column>
    </data-table-full-height>
  </div>
</template>

<script>
  import moment from 'moment'
  import { encode } from '../../query-encoder'

  export default {
    metaInfo: {title: 'Сервисы'},
    data () {
      return {
        filtersValue: null,
        data: {},
        sort: null,
        date: [
          moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
          moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        ],
        pickerOptions: {
          firstDayOfWeek: 1,
        },
        inn: null,
        fsNumber: null,
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = `${sort.prop}:${order}`
        } else {
          this.sort = null
        }
      },
      makeQuery (serial_number) {
        return encode({serial_number: [{label: serial_number, value: serial_number}]})
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/reports/service.vue